"use client";

import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../constants/config";
import { TeacherProfileView } from "./TeacherProfileView";

function MyProfile() {
  const [teacher, setTeacher] = useState(null);
  const [allSubjects, setAllSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchTeacherProfile();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axiosInstance.get(API_ENDPOINTS.subjects, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const list = res.data?.data?.subjects ?? res.data?.subjects ?? [];
        setAllSubjects(Array.isArray(list) ? list : []);
      } catch {
        setAllSubjects([]);
      }
    };
    fetchSubjects();
  }, []);

  const fetchTeacherProfile = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(API_ENDPOINTS.usersProfile, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.status === "success" && response.data.data.user) {
        const userData = response.data.data.user;
        if (userData.enrollment && !userData.assignment) {
          userData.assignment = userData.enrollment;
        }
        setTeacher(userData);
      } else {
        setError("Failed to fetch profile data");
      }
    } catch (err) {
      console.error("Error fetching teacher profile:", err);
      setError("Failed to fetch profile data: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[320px]">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-slate-300 border-t-slate-600" />
      </div>
    );
  }

  if (error && !teacher) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 text-red-800 px-4 py-3 text-center">
        {error}
      </div>
    );
  }

  if (!teacher) return null;

  return <TeacherProfileView teacher={teacher} allSubjects={allSubjects} />;
}

export default MyProfile;
